module.exports = __webpack_public_path__ + "static/img/sv-6.0010ba5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gallery/sv-6.jpg
// module id = ejJq
// module chunks = 0